import React from 'react';

import { StepDetail, Description, Subheader } from 'screens/MyJourney/details/StepDetail';

const ObWeek30Details = () => (
  <StepDetail>
    <Subheader>Return OB Appointment</Subheader>
    <Description>This appointment includes a visit with your provider & an ultrasound.</Description>
  </StepDetail>
);

export default ObWeek30Details;
